import Vue from 'vue';
// 注册一个全局自定义指令 `v-perm`
Vue.directive('perm', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: (el, binding, vnode) => {
        //获取自定义标签v-perm的值
        const value = binding.value;
        //json格式字符串
        let permissions = localStorage.getItem('permissions');
        if (permissions){
            //转成json对象
            let auths = JSON.parse(permissions);
            //将数组中的每一个元素按照,号进行拼接  然后 再检索
            if (auths.join(",").indexOf(value)==-1) {
                //如果不包含权限就移除
                el.parentNode.removeChild(el);
            }
        }
    }
});
// 注册全局自定义指令 `v-role`
Vue.directive('role', {
    inserted: (el, binding) => {
        const allowRoles = binding.value // 允许的角色数组
        let user = localStorage.getItem('logininfo')

        if (user) {
            user = JSON.parse(user)
            const role = user.account // 假设用户信息中含有角色字段 `account`

            // 如果不包含该角色就移除元素
            if (!allowRoles.includes(role)) {
                el.parentNode && el.parentNode.removeChild(el)
            }
        } else {
            // 没有用户信息就默认无权限
            el.parentNode && el.parentNode.removeChild(el)
        }
    }
});


// 注册全局自定义指令 `v-menus`
Vue.directive('menus', {
    bind: (el, binding, vnode) => {
        // 获取绑定的菜单名称
        const menuName = binding.value;

        // 从本地存储获取菜单列表
        let menus = localStorage.getItem('userMenus');

        if (menus) {
            try {
                menus = JSON.parse(menus);
                // 检查是否存在指定菜单
                const hasMenu = menus.some(menu => menu.name === menuName);

                // 如果不存在该菜单，则移除元素
                if (!hasMenu) {
                    el.parentNode && el.parentNode.removeChild(el);
                }
            } catch (e) {
                console.error('解析菜单数据失败:', e);
            }
        }
    },

    update: (el, binding) => {
        // 更新时的处理逻辑
        const menuName = binding.value;
        let menus = localStorage.getItem('userMenus');

        if (menus) {
            try {
                menus = JSON.parse(menus);
                const hasMenu = menus.some(menu => menu.name === menuName);

                // 控制元素显示/隐藏而不是移除
                el.style.display = hasMenu ? '' : 'none';
            } catch (e) {
                console.error('解析菜单数据失败:', e);
            }
        }
    }
});




// WEBPACK FOOTER //
// ./src/common/js/permission.js